import React, {useState} from "react";
import {enterFocus} from "../../../utils";

const SelectInput = (props) => {
    const [isFocus, setIsFocus] = useState(false);
    const {name, value, options, className, id, placeholder, onChange,  readOnly, disabled, hasError, nextFocus = ''} = props;
    const borderClass = hasError === true ? "border-red-500" : "border-tenken-gray-500";
    const backgroundColor = (readOnly || disabled) ? "bg-gray-200" : isFocus ? "bg-yellow-100" : "bg-white";
    const textColor = (readOnly || disabled) ? "text-gray-400" : "";
    const selectClass = `lg:h-10 h-[38px] lg:text-base text-[15px] border ${borderClass} ${backgroundColor} ${textColor} rounded-[6px] px-2 py-1.5 ${className || ''}`;

    const handleKeyDown = (e) => {
        if (nextFocus && e.key === 'Enter') {
            return enterFocus(nextFocus);
        }
        return e.target.blur();
    }
    return (
        <select
            name={name}
            className={selectClass}
            id={id ? id : null}
            value={value !== undefined ? value : null}
            placeholder={placeholder ? placeholder : null}
            readOnly={readOnly !== undefined ? readOnly : null}
            disabled={disabled !== undefined ? disabled : null}
            onChange={onChange !== undefined ? onChange : null}
            onFocus={(e) => setIsFocus(true)}
            onBlur={(e) => setIsFocus(false)}
            onKeyDown={(e) => handleKeyDown(e)}
        >
            {options.map((option, index) => (
                <option className="bg-white" key={index} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
}

export default SelectInput;